import React, { useEffect } from 'react';
import styled from 'styled-components';

export default function AddThis({ id }: { id: string }) {
  useEffect(() => {
    if (!id) return;
    const el = document.createElement('script');
    el.src = `//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-${id}`;
    el.type = 'text/javascript';
    el.async = true;
    (
      document.getElementsByTagName('head')[0] ||
      document.getElementsByTagName('body')[0]
    ).appendChild(el);
  }, [id]);

  return <AddThisCss className="addthis_inline_share_toolbox"></AddThisCss>;
}

const AddThisCss = styled.div`
  white-space: nowrap;
  padding-top: 10px;
  padding-left: 10px;

  ${p => p.theme.breakpoints.maxSm} {
    padding-left: 0;
  }
`;
